import {
  filter,
  flow,
  get,
  keys,
  mapValues,
  pick,
  pickBy,
  sampleSize,
  sortBy,
  toArray,
  shuffle,
} from 'lodash/fp'
import { isEmpty, map, reduce, set } from 'lodash'
import { setField } from 'cape-lodash'
import { buildFullEntity, entityTypeSelector, getGraphNode } from 'redux-graph'
import { selectForm } from 'redux-field'
import { createSelector } from 'reselect'
import parse from 'url-parse'
import { getGraphSlice } from './util'
import { studentsFilled } from './student'

export const getArtItems = entityTypeSelector('CreativeWork')
export const getSplashArt = entityTypeSelector('SplashArt')
// Needed to build refs.
export const artGraph = getGraphSlice(['CreativeWork', 'ImageObject', 'MediaObject'])

export const getAgentOf = get('rangeIncludes.agent')
export const createWorksOnly = pickBy({ type: 'CreativeWork' })
export const getAssociatedOf = get('rangeIncludes.associatedMedia')
export const getArtRefs = flow(
  getAgentOf,
  createWorksOnly
)

export function testFunc(input) {
  console.log('input')
  // console.log(input)
  return input
}

export function addUrlEmbed(input) {
  const filtered = filter('associatedMedia', input)
  mapValues((art) => {
    const url = get('associatedMedia', art)
    // const url = 'https://www.youtube.com/watch?v=clTgM2RyuRc'
    const parsed = parse(url, {}, true)
    if (parsed.hostname.includes('vimeo')) {
      // vimeo
      const data = {
        provider: 'Vimeo',
        url: {
          pathname: parsed.pathname,
          query: null,
        },
      }
      set(art, 'videoInfo', data)
    } else if (parsed.hostname.includes('youtube')) {
      // youtube
      const data = {
        provider: 'Youtube',
        url: {
          pathname: parsed.pathname,
          query: parsed.query,
        },
      }
      set(art, 'videoInfo', data)
    }
  }, filtered)
  return input
}

export const artFill = setField('position', ({ position, sortOrder }) =>
  parseInt(position || sortOrder || 0, 10))

export function expandGetFullEntities(graphSlice) {
  return mapValues(flow(
    getGraphNode(graphSlice),
    flow(
      buildFullEntity(1, graphSlice),
      artFill
    )
  ))
}
export function addStudentArt(graphSlice, student) {
  if (!student) return null
  return setField(
    'art',
    flow(
      getArtRefs,
      expandGetFullEntities(graphSlice),
      addUrlEmbed,
      sortBy(['position', 'title']),
      filter(item => item.image || item.associatedMedia)
    )
  )(student)
}
// Load art for every student in students object.
export function addStudentsArt(graphSlice, students) {
  if (isEmpty(students)) return students
  return mapValues(student => addStudentArt(graphSlice, student), students)
}
export const getSlideStudents = createSelector(
  flow(
    get('db.slideStudents'),
    keys
  ),
  studentsFilled,
  pick
)
export const getStudentsArt = createSelector(
  artGraph,
  studentsFilled,
  addStudentsArt
)
export const getSlideStudentsArt = createSelector(
  artGraph,
  getSlideStudents,
  addStudentsArt
)

export const slideStudentsArtOnly = students =>
  reduce(
    students,
    (result, { art, id, name }) =>
      result.concat(map(art, item => ({ ...item, studentId: id, studentName: name }))),
    []
  )

// Selected student art for splash slideshow.
export const studentSplashArt = createSelector(
  createSelector(
    getSlideStudentsArt,
    slideStudentsArtOnly
  ),
  flow(
    selectForm,
    get('refresh-art.value')
  ),
  sampleSize(7)
)

export const studentSlideArt = createSelector(
  createSelector(
    getStudentsArt,
    slideStudentsArtOnly
  ),
  sampleSize(12)
)

export const splashArt = flow(
  getSplashArt,
  toArray,
  shuffle
)

export const collageArt = flow(
  getSplashArt,
  toArray,
  shuffle,
  sampleSize(8)
)
// export const getArtwork = createSelector(userIsAgentOf, getArtItems, getArtRefs)
// artwork: state => map(getArtwork(state), item => getFullEntity(state, item)),
